var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'flex justify-center px-4 pt-3 w-full box-border',
    {
      'items-center': _vm.alignItems === 'center',
      'items-start': _vm.alignItems === 'start',
    },
  ]},[_c('div',{class:['flex justify-start', _vm.fixedWidth ? 'w-1/4' : 'flex-1']},[_vm._t("start-content")],2),_vm._v(" "),_c('div',{class:['flex justify-center', _vm.fixedWidth && 'w-1/2']},[_vm._t("center-content")],2),_vm._v(" "),_c('div',{class:['flex justify-end', _vm.fixedWidth ? 'w-1/4' : 'flex-1']},[_vm._t("end-content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }